import './Nav.css';

import { defineMessages, injectIntl } from 'react-intl';
import { Link,withRouter } from 'react-router-dom';
import PropTypes, { element } from 'prop-types';
import React, { Component } from 'react';
import alertIcon from './assets/icon-alert.svg';
import helpIcon from './assets/icon-help.svg';
import md5 from 'md5';
import { pure } from 'recompose';
import settingsIcon from './assets/icon-settings.svg';

import shiftLogo from './assets/fuse-logo-horizontal-180.svg';
import analyzerLogo from './assets/fuse-logo-horizontal-180.svg';
import translatorLogo from './assets/fuse-logo-horizontal-180.svg';
import Alert from "../../container/Alert";

const messages = defineMessages({
  navLogout: {
    id: 'nav.logout',
    description: 'alt tag on logout icon',
    defaultMessage: 'Logout'
  }
});

const print = status => {
  if (status.payload) {
    return status.payload.response;
  }
};

class Nav extends Component {
  state = {
    anchorEl: null
  };

  render() {
    const { username, logout, intl } = this.props;
    const { anchorEl } = this.state;

    return username ? (
      <div className="nav" style={{width : '600px'}}>
        <Alert
          title="Exception"
          message={print(this.props.status)}
          reset = {this.props.resetPopError}
          logout = {this.props.logout}
        />
        {/* {(this.props.location.pathname === '/en-CA/' || */}
        {(this.props.location.pathname === '/en-CA/datafactorymanagement') &&
        this.props.role.includes('CUSTOMER_ADMIN') && (
          <Link to="/en-CA/management" style={{position: 'absolute', right: '210px'}}>
            <button
              className="button"
              style={{ marginRight: '40px'}}
              type="button"
            >
              USER MANAGEMENT
            </button>
          </Link>
        ) }
        {(this.props.location.pathname === '/en-CA/' ||
          this.props.location.pathname === '/en-CA/shift') &&
        (this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER'))  && (
          <Link to="/en-CA/dashboard">
            <button
              className="button"
              style={{ marginRight: '40px' }}
              type="button"
            >
              DASHBOARD
            </button>
          </Link>
        ) }

        <ul className="links">
          <li style={{ display: 'none' }}>
            <img alt="" src={helpIcon} />
          </li>
          <li style={{ display: 'none' }}>
            <img alt="" src={settingsIcon} />
          </li>
          <li style={{ display: 'none' }}>
            <img alt="" src={alertIcon} />
          </li>
          <li className="nav_username_box">
            <a href="" onClick={logout}>
              <img
                className="gravatar"
                alt={intl.formatMessage(messages.navLogout)}
                src={`https://www.gravatar.com/avatar/${md5(
                  username.trim().toLowerCase()
                )}?d=mm`}
              />
            </a>
            <i className="nav_username">{this.props.username}</i>
          </li>
        </ul>
        <div className="logo">
          {/*<Link to="/">*/}
            {this.props.location.pathname !== '/en-CA/translation'
              && this.props.location.pathname !== '/en-CA/assessment/standard'
              && this.props.location.pathname !== '/en-CA/assessment/free' ? (
              <img alt="FUSE" src={shiftLogo} width="225" height="58" />
            ) : null}
            {this.props.location.pathname === '/en-CA/assessment/free'
              || this.props.location.pathname === '/en-CA/assessment/standard'? (
              <img alt="FUSE" src={analyzerLogo} width="144" height="58" />
            ) : null}
            {this.props.location.pathname === '/en-CA/translation' ? (
              <img alt="FUSE" src={translatorLogo} width="144" height="58" className="trans_logo"/>
            ) : null}
          {/*</Link>*/}
        </div>
      </div>
    ) : (
      <div className="nav">
        <Alert
          title="Exception"
          message={print(this.props.status)}
          reset = {this.props.resetPopError}
          logout = {this.props.logout}
        />
        <div className="logo">
          <Link to="/">
            <img alt="FUSE" src={shiftLogo} width="144" height="58" />
          </Link>
        </div>
      </div>
    );
  }
}

Nav.propTypes = {
  username: PropTypes.string,
  logout: PropTypes.func.isRequired,
  intl: PropTypes.object
};

export default withRouter(pure(injectIntl(Nav)));



// WEBPACK FOOTER //
// ./src/components/views/Nav/index.js